import moment from 'moment'
import { useStore } from 'vuex'
import userSiteRoles from '../const/userSiteRoles'
import userRoles from '../const/userRoles'
import nodeTypes from "../const/nodeTypes";
import filedTypes from "../const/fieldTypes";
import alartTypes from "../const/alartTypes";
import alartStatuses from "../const/alartStatuses";
import Encoding from "encoding-japanese";
import fieldTypes from "../const/fieldTypes";
import axios from 'axios';

export const canRead = (nodeId, store = null) => {
  if (getSiteRoleCodeFromFacility(nodeId, store)) {
    return true
  } else {
    return false
  }
}

export const isAdmin = (userInfo) => {
    return userInfo.user_role.code == userRoles.Admin
}

export const isAdvanced = (userSiteRoleCode) => {
  return userSiteRoleCode === userSiteRoles.advanced || userSiteRoleCode === userSiteRoles.power
}

export const isDeveloper = (userSiteRoleCode) => {
  return userSiteRoleCode === userSiteRoles.developer || userSiteRoleCode === userSiteRoles.power
}

export const isRealAdvanced = (userSiteRoleCode) => {
  return userSiteRoleCode === userSiteRoles.advanced
}

export const isAdminOrganization = (userInfo, store = null) => {
  const $store = store ? store : useStore()
  const organization = $store.state.common.organization.find((item) => item.code === userInfo.organization_code)
  if (organization === undefined) {
    return false
  }
  return organization.admin
}

export const getSiteRoleCodeFromFacility = (node_id, store = null) => {
  const $store = store ? store : useStore()
  const _node = getFacility(node_id, $store)
  return _node ? getSiteRoleCode(_node.site_id, $store) : null
}

export const getFacility = (node_id, store = null) => {
  const $store = store ? store : useStore()
  return $store.state.common.nodes.find((item) => item.id === parseInt(node_id))
}

export const getSiteRoleCodeFromPlant = (plant_id, store = null) => {
  const $store = store ? store : useStore()
  const _plant = getPlant(plant_id, $store)
  return _plant ? getSiteRoleCode(_plant.site_id, $store) : null
}

export const getPlant = (plant_id, store = null) => {
  const $store = store ? store : useStore()
  return $store.state.common.plants.find((item) => item.id === parseInt(plant_id))
}

export const getSiteRoleCode = (site_id, store = null) => {
  const $store = store ? store : useStore()
  if ($store.state.common.userInfo.user_role.code == userRoles.Admin) {
    return userSiteRoles.power
  }
  if ($store.state.common.userInfo.user_sites) {
    const role = $store.state.common.userInfo.user_sites.find((item) => item.site_id === parseInt(site_id))
    if (role === undefined) {
      return null
    }
    return role.user_site_role_id
  } else {
    return null
  }
}

export const getNodeType = (node) => {
  if (!(node && node.is_auth !== null && node.is_auth !== undefined && node.is_data !== null && node.is_data !== undefined))
    return null
  if (node.is_auth && !node.is_data)
    return nodeTypes.ROOT
  else if (!node.is_auth && !node.is_data)
    return nodeTypes.MEDIUM
  else if (!node.is_auth && node.is_data)
    return nodeTypes.TERMINAL
  else
    return null
}

export const getNodeTypeName = (nodeType) => {
  if (nodeType === nodeTypes.ROOT) {
    return 'ルート階層'
  } else if (nodeType === nodeTypes.MEDIUM) {
    return '中間階層'
  } else if (nodeType === nodeTypes.TERMINAL) {
    return '末端階層'
  } else {
    return '不正階層'
  }
}

export const parseNodeType = (nodeType) => {
  if (nodeType === nodeTypes.ROOT) {
    return {is_auth: true, is_data: false}
  } else if (nodeType === nodeTypes.MEDIUM) {
    return {is_auth: false, is_data: false}
  } else if (nodeType === nodeTypes.TERMINAL) {
    return {is_auth: false, is_data: true}
  } else {
    return null
  }
}

/**
 * @param {String} fileName ファイル名
 * @param {Array} column カラム
 * @param {Array} rows データ
 * @param {String} extention [csv, tsv]
 */
export const exportCsv = (barRef, fileName = null, columns = [], rows = [], extension = 'csv') => {
  barRef.start()
  const ext = extension === 'csv' ? ',' : "\t"
  let header = ''
  let body = ''

  let columnArray = []
  columns.forEach(item => {
    columnArray.push(item.label)
  })
  header = columnArray.join(ext)

  let bodyArray = []
  if (columns.length > 0) {
    rows.forEach(item => {
      bodyArray = []
      columns.forEach(column => {
        if (typeof column.field === "function") {
          bodyArray.push(column.field(item))
        } else if (item[column.field] !== undefined) {
          if (column.putQuote !== undefined && column.putQuote === true)
            bodyArray.push(`"${item[column.field]}"`)
          else
            bodyArray.push(item[column.field])
        }
      })
      body += bodyArray.join(ext) + "\r\n"
    })
  } else {
    rows.forEach(item => {
      body += item.join(ext) + "\r\n"
    })
  }

  const csv = (header ? header + "\r\n" : "") + body

  let error = false;
  let exportFileName = fileName !== null ? fileName : 'export'
  // const sjisCsv = csv.map(row => {
  //   return row.map(column => {
  //     return Encoding.convert(column, { to: 'SJIS', from: 'UNICODE' })
  //   })
  // })
  const sjisCsv = Encoding.stringToCode(csv)
  const convert = Encoding.convert(sjisCsv, { to: 'SJIS', from: 'UNICODE' });
  const bom = new Uint8Array(convert)
  const blob = new Blob([bom], { type: `text/csv` })
  // const bom = new Uint8Array([0xef, 0xbb, 0xbf])
  // const blob = new Blob([bom, csv], { type: `text/csv` })
  if (navigator.msSaveBlob) { // for IE 10+
    navigator.msSaveBlob(blob, exportFileName);
  } else {
    //anchorを生成してclickイベントを呼び出す。
    const link = document.createElement('a');
    if (link.download !== undefined) {
      var url = URL.createObjectURL(blob)
      link.setAttribute("href", url)
      link.setAttribute("download", exportFileName)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
  barRef.stop()
}

// FIXME 稼働状況画面でしか使えない関数な気がするので OperatingSummary.vue へ移動が必要
/**
 * @param {String} fileName ファイル名
 * @param {Array} column カラム
 * @param {Array} rows データ
 * @param {String} extention [csv, tsv]
 */
export const exportOperatingSummaryCsv = (barRef, fileName = null, columns = [], rows = [], extension = 'csv') => {
  barRef.start()
  const ext = extension === 'csv' ? ',' : "\t"
  let header = ''
  let body = ''

  let columnArray = []
  columns.forEach(item => {
    columnArray.push(item.label)
  })
  header = columnArray.join(ext)

  let bodyArray = []
  if (columns.length > 0) {
    rows.forEach(item => {
      bodyArray = []
      const series_list = item.series
      console.log(series_list)
      columns.forEach(column => {
        if (item[column.field] !== undefined) {
          if (column.putQuote !== undefined && column.putQuote === true)
            bodyArray.push(`"${item[column.field]}"`)
          else
            bodyArray.push(item[column.field])
        }
      })
      bodyArray[1].forEach((series, index) => {
        const bodyParts = []
        let rowData = []
        bodyParts.push(bodyArray[0])
        if(series.group == ""){
          bodyParts.push("(なし)")
        }else{
          bodyParts.push(series.group)
        }
        bodyArray[2][index].forEach((list,inx) => {
          list.forEach((value, i) => {
            if(value == 1){
              rowData[i] = series_list[index].names[inx]
            }
            if(rowData[i] == undefined){
              rowData[i] = "停止中"
            }
          })
        })
        bodyParts.push(rowData)
        body += bodyParts.join(ext) + "\r\n"
      })

    })
  } else {
    rows.forEach(item => {
      body += item.join(ext) + "\r\n"
    })
  }

  const csv = (header ? header + "\r\n" : "") + body

  let error = false;
  let exportFileName = fileName !== null ? fileName : 'export'
  // const sjisCsv = csv.map(row => {
  //   return row.map(column => {
  //     return Encoding.convert(column, { to: 'SJIS', from: 'UNICODE' })
  //   })
  // })
  const sjisCsv = Encoding.stringToCode(csv)
  const convert = Encoding.convert(sjisCsv, { to: 'SJIS', from: 'UNICODE' });
  const bom = new Uint8Array(convert)
  const blob = new Blob([bom], { type: `text/csv` })
  // const bom = new Uint8Array([0xef, 0xbb, 0xbf])
  // const blob = new Blob([bom, csv], { type: `text/csv` })
  if (navigator.msSaveBlob) { // for IE 10+
    navigator.msSaveBlob(blob, exportFileName);
  } else {
    //anchorを生成してclickイベントを呼び出す。
    const link = document.createElement('a');
    if (link.download !== undefined) {
      var url = URL.createObjectURL(blob)
      link.setAttribute("href", url)
      link.setAttribute("download", exportFileName)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
  barRef.stop()
}

/**
 * スペース区切りでのフィルター
 * @param {arrya} array
 * @param {string} keyword
 * @returns
 */
export const andFilter = (array, keyword, column) => {
  const kanas = {
    'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
    'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
    'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
    'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
    'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
    'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
    'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
    'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
    'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
    'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
    'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
    'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
    'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
    'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
    'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
    'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
    'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
    'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
    '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
  };
  const reg = new RegExp('(' + Object.keys(kanas).join('|') + ')', 'g');
  const normalize = (s) => {
    let newString = s.replace(reg, (match) => kanas[match]).replace(/ﾞ/g, '゛').replace(/ﾟ/g, '゜');
    newString = newString.replace(/[！-～]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });
    newString = newString.replace(/　/g, ' ');
    return newString;
  }
  let searchValue = normalize(keyword)
  const searchArray = searchValue.split(' ')
  let trueCount = 0
  return array.filter((item) => {
    // 検索ワードが空欄はすべてtrue
    if (searchValue === '') {
      return true
    }
    trueCount = 0

    // テーブルカラムを結合
    const combinWords = column
      .map(colum => {
        if (Array.isArray(colum.name)) {
          let ar = {...item}
          for (let i in colum.name) {
            ar = ar[colum.name[i]]
          }
          return ar ?? ''
        } else {
          return item[colum.name] ? normalize(item[colum.name].toString().toLowerCase()) : ''
        }
      })
      .reduce((prev, current) => prev + current)
    // 検索ワードの配列をループ
    for (let j = 0; j < searchArray.length; j++) {
      if (combinWords.toLowerCase().includes(searchArray[j].toLowerCase())) {
        trueCount++
      }
    }
    if (trueCount === searchArray.length) {
      return true
    }
    return false
  })
}

export const wheelZoomXYPlugin = (opts) => {
    let factor = opts.factor || 0.75;

    let xMin, xMax, yMin, yMax, xRange, yRange;

    function clamp(nRange, nMin, nMax, fRange, fMin, fMax) {
      if (nRange > fRange) {
        nMin = fMin;
        nMax = fMax;
      }
      else if (nMin < fMin) {
        nMin = fMin;
        nMax = fMin + nRange;
      }
      else if (nMax > fMax) {
        nMax = fMax;
        nMin = fMax - nRange;
      }

      return [nMin, nMax];
    }

    return {
      hooks: {
        ready: u => {
          xMin = Math.min(u.scales.x.min, u.data[0][0]);
          xMax = Math.max(u.scales.x.max, u.data[0][u.data[0].length - 1]);
          yMin = Math.min(u.scales.y.min, u.data[1][0]);
          yMax = Math.max(u.scales.y.max, u.data[1][u.data[1].length - 1]);

          xRange = xMax - xMin;
          yRange = yMax - yMin;

          let over = u.over;
          let rect = over.getBoundingClientRect();

          // wheel drag pan
          over.addEventListener("mousedown", e => {
            if (e.button == 1) {
            //	plot.style.cursor = "move";
              e.preventDefault();

              let left0 = e.clientX;
            //	let top0 = e.clientY;

              let scXMin0 = u.scales.x.min;
              let scXMax0 = u.scales.x.max;

              let xUnitsPerPx = u.posToVal(1, 'x') - u.posToVal(0, 'x');

              function onmove(e) {
                e.preventDefault();

                let left1 = e.clientX;
              //	let top1 = e.clientY;

                let dx = xUnitsPerPx * (left1 - left0);

                u.setScale('x', {
                  min: scXMin0 - dx,
                  max: scXMax0 - dx,
                });
              }

              function onup(e) {
                document.removeEventListener("mousemove", onmove);
                document.removeEventListener("mouseup", onup);
              }

              document.addEventListener("mousemove", onmove);
              document.addEventListener("mouseup", onup);
            }
          });

          // wheel scroll zoom
          over.addEventListener("wheel", e => {
            e.preventDefault();

            let {left, top} = u.cursor;
            const scaleX = u.axes[0].scale
            const scaleY = u.axes[1].scale

            let leftPct = left/rect.width;
            let btmPct = 1 - top/rect.height;
            let xVal = u.posToVal(left, scaleX);
            let yVal = u.posToVal(top, scaleY);
            let oxRange = u.scales[scaleX].max - u.scales[scaleX].min;
            let oyRange = u.scales[scaleY].max - u.scales[scaleY].min;
            let nxRange = e.deltaY < 0 ? oxRange * factor : oxRange / factor;
            let nxMin = xVal - leftPct * nxRange;
            let nxMax = nxMin + nxRange;
            [nxMin, nxMax] = clamp(nxRange, nxMin, nxMax, xRange, xMin, xMax);

            let nyRange = e.deltaY < 0 ? oyRange * factor : oyRange / factor;
            let nyMin = yVal - btmPct * nyRange;
            let nyMax = nyMin + nyRange;
            [nyMin, nyMax] = clamp(nyRange, nyMin, nyMax, yRange, yMin, yMax);

            u.batch(() => {
              u.setScale(scaleX, {
                min: nxMin,
                max: nxMax,
              });

              u.setScale(scaleY, {
                min: nyMin,
                max: nyMax,
              });
            });
          }, {passive: false});
        }
      }
    };
  }

export const wheelZoomPlugin = (opts) => {
  let factor = opts.factor || 0.75;

  let xMin, xMax, yMin, yMax, xRange, yRange;

  function clamp(nRange, nMin, nMax, fRange, fMin, fMax) {
    if (nRange > fRange) {
      nMin = fMin;
      nMax = fMax;
    }
    else if (nMin < fMin) {
      nMin = fMin;
      nMax = fMin + nRange;
    }
    else if (nMax > fMax) {
      nMax = fMax;
      nMin = fMax - nRange;
    }

    return [nMin, nMax];
  }

  return {
    hooks: {
      ready: u => {
        xMin = Math.min(u.scales.x.min, u.data[0][0]);
        xMax = Math.max(u.scales.x.max, u.data[0][u.data[0].length - 1]);
        yMin = u.scales.y.min;
        yMax = u.scales.y.max;

        xRange = xMax - xMin;
        yRange = yMax - yMin;

        let over = u.over;
        let rect = over.getBoundingClientRect();

        // wheel drag pan
        over.addEventListener("mousedown", e => {
          if (e.button == 1) {
          //	plot.style.cursor = "move";
            e.preventDefault();

            let left0 = e.clientX;
          //	let top0 = e.clientY;

            let scXMin0 = u.scales.x.min;
            let scXMax0 = u.scales.x.max;

            let xUnitsPerPx = u.posToVal(1, 'x') - u.posToVal(0, 'x');

            function onmove(e) {
              e.preventDefault();

              let left1 = e.clientX;
            //	let top1 = e.clientY;

              let dx = xUnitsPerPx * (left1 - left0);

              u.setScale('x', {
                min: scXMin0 - dx,
                max: scXMax0 - dx,
              });
            }

            function onup(e) {
              document.removeEventListener("mousemove", onmove);
              document.removeEventListener("mouseup", onup);
            }

            document.addEventListener("mousemove", onmove);
            document.addEventListener("mouseup", onup);
          }
        }, {passive: false});

        // wheel scroll zoom
        over.addEventListener("wheel", e => {
          e.preventDefault();
          if (!rect.width){
            rect = over.getBoundingClientRect();
          }

          let { left, top } = u.cursor;
          const scaleX = u.axes[0].scale
          const scaleY = u.axes[1].scale

          let leftPct = left/rect.width;
          let btmPct = 1 - top/rect.height;
          let xVal = u.posToVal(left, scaleX);
          let yVal = u.posToVal(top, scaleY);
          let oxRange = u.scales[scaleX].max - u.scales[scaleX].min;
          let oyRange = u.scales[scaleY].max - u.scales[scaleY].min;
          let nxRange = e.deltaY < 0 ? oxRange * factor : oxRange / factor;
          let nxMin = xVal - leftPct * nxRange;
          let nxMax = nxMin + nxRange;
          [nxMin, nxMax] = clamp(nxRange, nxMin, nxMax, xRange, xMin, xMax);

          let nyRange = e.deltaY < 0 ? oyRange * factor : oyRange / factor;
          let nyMin = yVal - btmPct * nyRange;
          let nyMax = nyMin + nyRange;
          [nyMin, nyMax] = clamp(nyRange, nyMin, nyMax, yRange, yMin, yMax);

          if (nxMax - nxMin > 0){
            u.batch(() => {
              u.setScale(scaleX, {
                min: nxMin,
                max: nxMax,
              });

              u.setScale(scaleY, {
                min: nyMin,
                max: nyMax,
              });
            });
          }
        }, {passive: false});
      }
    }
  };
}

export const characterUnification = (str) => {
}

/**
 * 要素ドラッグ処理
 */
export class Draggable{
  draggingItem = null
  constructor() { }
  dragstart(item, e) {
    this.draggingItem = item
    e.dataTransfer.effectAllowed = 'move'
    // e.target.style.opacity = 0.2
    // e.stopPropagation()
  }
  dragenter(item, e) {
    [item.order, this.draggingItem.order] = [this.draggingItem.order, item.order]
    // e.cancelable !== false && e.preventDefault()
  }
  dragover(e) {
    e.dataTransfer.dropEffect = 'move'
    // e.preventDefault()
    // e.stopPropagation()
  }
  dragend(e) {
    // e.target.style.opacity = 1
    // this.draggingItem = null
  }
}


export const getTerminalNodes = (node) => {
  let total = getNodeType(node) == nodeTypes.TERMINAL ? [node] : [];
  for (const childNode of node.children_detail){
    total = total.concat(getTerminalNodes(childNode))
  }
  return total;
}


export const formatDate = (date) => date ? moment(formatISO(date)).format("YYYY/MM/DD HH:mm:ss") : "";
export const startTimeOfDate = (date) => moment(formatISO(date), "YYYY/MM/DD").startOf('day').valueOf();
export const endTimeOfDate = (date) => moment(formatISO(date), "YYYY/MM/DD").endOf('day').valueOf();
export const readBlobAsDataUrl = async (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {resolve(reader.result)};
    reader.onerror = (e) => {reject(e);}
    reader.readAsDataURL(blob);
  })
}

export const formatISO = (date) => {
  // moment() 使用時に下記 warning に対応するための関数
  // Deprecation warning: value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged.
  try {
    // toISOString()は常にUTCで出力されるため、JSTに変換してからISO形式の文字列を生成する

    // 日本時間のオフセット（9時間）をミリ秒で計算
    const offset = 9 * 60 * 60 * 1000;
    // タイムゾーンを日本時間に合わせて補正した新しい日付オブジェクトを生成
    const jstDate = new Date(date.getTime() + offset);

    // UTCとしてISO文字列を作成し、末尾の'Z'（UTC）を日本時間のオフセット'+09:00'に置換
    return jstDate.toISOString().replace('Z', '+09:00');
  } catch(e) {
    return date
  }
}

export const setIntervalImmediately = (func, interval) => {
  func();
  return setInterval(func, interval);
}

export function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

export function formatDuration(value) {
  // value is time duration in milliseconds
  const numSec = value / 1000;
  const hours = Math.floor(numSec / 3600);
  const minutes = Math.floor((numSec - hours * 3600) / 60);
  const seconds = Math.floor(numSec - hours * 3600 - minutes * 60);
  let durationString = "";
  if (hours > 0) {
      durationString += `${hours}時間 `;
  }
  if (minutes > 0) {
      durationString += `${minutes}分 `;
  }
  durationString += `${seconds}秒`;
  return durationString;
}

/**
 * Calculate moving averages.
 * @param {Array<number>} timestamps Sorted array of timestamps (milliseconds).
 * @param {Array<number>} values Values array of length equal to timestamps.
 * @param {number} interval Interval of moving average (milliseconds).
 * @returns {Array<number>} Array of moving averages.
 */
export function timeBasedMovingAverage(timestamps, values, interval) {
  // timestamps, values は同じ長さ
  // timestamps はソート済み
  const items = timestamps.map(
    (timestamp, i) => {
      return {timestamp, value: values[i]}
    }
  )
  const results = items.reduce(
    (acc, item) => {
      const startTimestamp = item.timestamp - interval;
      while(
        acc.windowItems.length > 0
        && acc.windowItems[0].timestamp < startTimestamp
      ) {
        const first = acc.windowItems.shift();
        acc.sum -= first.value;
      }
      if (item.value != null) {
        acc.sum += item.value;
        acc.windowItems.push(item);
        acc.movingAverages.push(
          acc.sum / acc.windowItems.length
        );
      } else {
        acc.movingAverages.push(null);
      }
      return acc;
    },
    {
      /** @type {Array<number>} */
      movingAverages: [],
      /** @type {Array<{timestamp: number, value: number}>} */
      windowItems: [],
      /** @type {number} */
      sum: 0
    }
  )
  return results.movingAverages;
}

export function addTabClosingWarning() {
  window.onbeforeunload = (e) => {
      e = e || window.event;

      // For IE and Firefox prior to version 4
      if (e) {
          e.returnValue = "";
      }

      // For Safari
      return "";
  };
}

export function clearTabClosingWarning() {
  window.onbeforeunload = () => {};
}

export const saveFile = (blob, name) => {
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.download = name;
  a.href = blobUrl;
  a.click();
  URL.revokeObjectURL(blob);
}

/**
 * Get api response data or return default value when error is occured.
 * @param {Promise} response
 * @param {Any} defaultVal
 * @returns {Promisse} Of api response data of defaultVal
 */
export const getApiRes = async (response, defaultVal) => {
  try {
    const res = await response;
    return res.data ?? defaultVal;
  } catch (e) {
    console.log(e)
  }
  return defaultVal;
}


/**
 * Assign a value to obj by path of properties.
 * @param {Any} obj Object assigned.
 * @param {Array<string>} path Path of properties.
 * @param {Any} value Value to assgin.
 * @returns {Any} Object.
 */
export function deepAssign(obj, path, value) {
    let child = obj;
    for(const propertyName of path.slice(0, -1)){
      child[propertyName] = child[propertyName] || {};
      child = child[propertyName];
    }
    child[path[path.length -1]] = value;
    return obj
}


/**
 * Parse image id
 * @params {string} imageId
 * @returns {Object} {timestamp, imageFileName}
 */
export function parseImageId(imageId) {
  const [head, ...tail] = imageId.split("---");
  return {
    timestamp: parseInt(head),
    imageFileName: tail.join("---")
  }
}


/**
 * Show display field type
 * @params {string} field_type
 * @returns {string} display fieldtype
 */
export function displayFieldType(fieldType) {
  if (fieldType === 'analog') {
    return 'アナログ'
  } else if (fieldType === 'alarm') {
    return '警報'
  } else if (fieldType === 'process') {
    return '工程'
  } else if (fieldType === 'operation') {
    return '運転'
  } else if (fieldType === 'setting') {
    return '設定'
  } else if (fieldType === 'saiik') {
    return 'SaiIK'
  } else if (fieldType === 'saicrew') {
    return 'SaiCrew'
  } else if (fieldType === 'saisense') {
    return 'SaiSense'
  } else {
    return ''
  }
}


/**
 * Resize image
 * @params {dataUrl} base64 encoded image data
 * @params {number} newWidth
 * @params {number} newHeight
 * @returns {Promise} resized image {dataUrl, width, height}
 */
export function resizeImage(dataUrl, newWidth, newHeight) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    image.onload = () => {
      newWidth = newWidth || image.width;
      newHeight = newHeight || Math.floor(newWidth * (image.height / image.width));
      canvas.width = newWidth;
      canvas.height = newHeight;
      ctx.drawImage(image, 0, 0, newWidth, newHeight);
      resolve({
        originWidth: image.width,
        originHeight: image.height,
        width: newWidth,
        height: newHeight,
        dataUrl: canvas.toDataURL()
      });
    }
    image.onerror = () => {
      reject();
    }
    image.src = dataUrl;
  })
}


/**
 * Crop image
 * @params {dataUrl} base64 encoded image data
 * @params {number} x
 * @number {number} y
 * @params {number} newWidth
 * @params {number} newHeight
 * @returns {Promise} cropped image {dataUrl, width, height}
 */
export function cropImage(dataUrl, x, y, newWidth, newHeight) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    image.onload = () => {
      canvas.width = newWidth;
      canvas.height = newHeight;
      ctx.drawImage(image, -x, -y);
      resolve({
        width: newWidth,
        height: newHeight,
        dataUrl: canvas.toDataURL()
      });
    }
    image.onerror = () => {
      reject();
    }
    image.src = dataUrl;
  })
}

/**
 * Draw box
 * @params {string} dataUrl base64 encoded image data
 * @params {Array} bboxes List of {x, y, width, height, stroke, lineWidth}
 * @params {number} ignore, ignore threshold of box size
 * @returns {Promise} dataUrl of image with overlay
 */
export function drawBboxOverlay(dataUrl, bboxes, ignore) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    ignore = ignore || 0;
    image.onload = () => {
      canvas.width = image.width;
      canvas.height = image.height;
      ctx.drawImage(image, 0, 0);

      for (const box of bboxes){
        if (box.x > ignore || box.y > ignore || canvas.width - box.width > ignore || canvas.height - box.height > ignore){
          ctx.save();

          ctx.lineWidth = box?.lineWidth ?? 2;
          ctx.strokeStyle = box?.stroke ?? "rgb(100, 255, 0)";
          ctx.beginPath();
          ctx.rect(box.x, box.y, box.width, box.height);
          ctx.stroke();

          ctx.restore();
        }
      }
      resolve({
        dataUrl: canvas.toDataURL()
      });
    }
    image.onerror = () => {
      reject();
    }
    image.src = dataUrl;
  })
}

/**
 * addBorder
 * @params {string} dataUrl base64 encoded image data
 * @params {Array} borders List of {color, width}
 * @returns {Promise} dataUrl of image with overlay
 */
export function addBorder(dataUrl, borders) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const defaultWidth = 2;
    const totalBorderWidth = borders.reduce((total, border) => total + (border.width || defaultWidth),0);
    image.onload = () => {
      canvas.width = image.width + totalBorderWidth * 2;
      canvas.height = image.height + totalBorderWidth * 2;
      ctx.drawImage(image, totalBorderWidth, totalBorderWidth);
      ctx.save();
      let borderStart = 0;
      for (const border of borders){
        ctx.lineWidth = border?.width ?? defaultWidth;
        ctx.strokeStyle = border?.color ?? "black";
        ctx.beginPath();
        ctx.rect(
          borderStart + ctx.lineWidth / 2,
          borderStart + ctx.lineWidth / 2,
          canvas.width - 2 * borderStart - ctx.lineWidth,
          canvas.height - 2 * borderStart - ctx.lineWidth
        );
        ctx.stroke();
        borderStart += ctx.lineWidth;
      }
      ctx.restore();
      resolve({
        dataUrl: canvas.toDataURL()
      });
    }
    image.onerror = () => {
      reject();
    }
    image.src = dataUrl;
  })
}


/**
 * Image size
 * @params {dataUrl} base64 encoded image data
 * @returns {Promise} size of image and dataUrl
 */
export function getImageSize(dataUrl) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      resolve({
        width: image.width,
        height: image.height,
        dataUrl: dataUrl
      });
    }
    image.onerror = () => {
      reject();
    }
    image.src = dataUrl;
  })
}

/**
 * Calculate margin for drawing box to prevent line is not displayed on edge of image
 * @param {x, y, with, height} box
 * @param {width, height} imageSize
 * @param {int} margin
 * @returns {left, top, right, bottom}
 */
export function calcDrawMargin(box, imageSize, margin){
  const left = box.x < 1 ? margin : 0;
  const top = box.y < 1 ? margin : 0;
  const right = box.width + box.x + left > imageSize.width - 1 ? margin + left : 0;
  const bottom = box.height + box.y + top > imageSize.height - 1 ? margin + top: 0;
  return {left, top, right, bottom}
}

/**
 * SL-GMS model url
 * @params {gts} Graphic tab setting object
 * @returns {String} S3 URL
 */
export function getSlGmsUrl(nodeCode, gts) {
  let url
  if (gts.tab_index !== undefined && gts.file_version) {
    // v2.1以降
    url = `swc-api/graphic/sl-gms-model/${nodeCode}/${gts.tab_index}/${gts.file_version}/${gts.file_name}`
  } else {
    // v2.0以前
    url = `swc-api/graphic/sl-gms-model/${nodeCode}/${gts.file_name}`
  }
  return url
}

/**
 * Get graphicTabSettings index by URL
 * @param {*} graphicTabSettings Graphic tab setting object
 * @param {String} url window.location.href
 * @returns graphicTabSettings index
 */
export function getGraphicTabIndex(graphicTabSettings, url) {
  let tabIndex = null
  if (url == null || url == "" || graphicTabSettings == null) {
    return tabIndex
  }
  const urlParts = url.split("/")
  const tabHtml = urlParts[urlParts.length - 1]
  graphicTabSettings.value.forEach(function(tabs, index) {
    if (tabHtml == tabs.file_name) {
      tabIndex = index
    }
  })
  return tabIndex
}

/**
 *
 * @param {*} fieldSetting
 * @returns
 */
export const getUnit = (fieldSetting) => {
  const bits = ['alarm', 'process', 'operation']
  const isBit = bits.includes(fieldSetting.field_type)
  return isBit ? 'bit' : (!fieldSetting.unit || fieldSetting.unit === '') ? null : fieldSetting.unit
}

const hideUnits = ['bit']
export const getHideUnit = (unit = null) => {
  if (unit === '') {
    return 'bit'
  } else {
    return unit
  }
}

export const isHideUnit = (unit) => {
  return hideUnits.includes(unit)
}

const noneUnits = [null, 'ph']
export const isNoneUnit = (unit) => {
  return noneUnits.includes(unit)
}

export const isBit = (unit) => {
  return unit === 'bit'
}


/**
 * Filter out null value from object
 * @param {Object} d
 * @returns Object with null value filtered out
 */
export function filterNullProperties(d) {
  return JSON.parse(JSON.stringify(d, (key, value) => {
    if (key != null && key != "null" && key != "undefined" && value !== null) return value;
  }));
}

/** Deep copy
 * @param {Object} o
 */
export function deepCopy(o) {
  return JSON.parse(JSON.stringify(o));
}


/**
 * Unique array by key
 * @param {Array} arr
 * @param {String} key
 * @returns {Array} unique array
 */
export function uniqueArray(arr, key) {
  const uniqueIds = new Set();

  const unique = arr.filter(element => {
    const isDuplicate = uniqueIds.has(element?.[key]);
    uniqueIds.add(element?.[key]);
    if (!isDuplicate) {
      return true;
    }
    return false;
  });
  return unique;
}

/**
 * Compare 2 string
 * @param {String} a
 * @param {String} b
 * @returns {number}
 */
export function lowerCompare(a, b) {
  return a?.toLowerCase()?.localeCompare(b?.toLowerCase()) ?? 0;
}


/**
 * Read PNG IHDR header
 * @param {ArrayBuffer} buffer buffer of image data
 */

export function readPngImageHeader(buffer) {
    var view = new DataView(buffer);

    // is a PNG?
    if (view.getUint32(0) === 0x89504E47 && view.getUint32(4) === 0x0D0A1A0A) {
      // We know format field exists in the IHDR chunk. The chunk exists at
      // offset 8 +8 bytes (size, name) +8 (depth) & +9 (type)
      var depth = view.getUint8(8 + 8 + 8);
      var type  = view.getUint8(8 + 8 + 9);

      return {
        depth: depth,
        type: ["G", "", "RGB", "Indexed", "GA", "", "RGBA"][type],
        buffer: view.buffer,
        hasAlpha: type === 4 || type === 6  // grayscale + alpha or RGB + alpha
      }
    }
    return {};
}


/**
 * Escape csv value
 * @param {String | null | undefined} v
 * @returns {String}
 */
export function escapeCsvValue(v) {
  if (v == null) {
    return "";
  }
  return '"' + v.replace('"', '""') + '"';
}

export const getAlartType = (dataset_id, fieldType) => {
  if (fieldType === filedTypes.SAIIK){
    // Note: saiik alarm end with '_sysalart'
    return alartTypes.AI
  } else if (fieldType === fieldTypes.NOTIFY_AI) {
    return alartTypes.AI
  } else if (dataset_id === 'aws_health_history') {
    return alartTypes.SYSTEM
  } else if (dataset_id.endsWith('_n_history') || dataset_id.endsWith('_notify')){
    return alartTypes.NOTIFY
  } else if (dataset_id.endsWith('_sysalart')){
    return alartTypes.IOT
  } else {
    if (fieldType === filedTypes.IOTALART){
      return alartTypes.IOT
    } else {
        return alartTypes.ALARM
    }
  }
}

export const getDatasetAlartType = (dataset_id, alartType) => {
    if (alartType === filedTypes.SAIIK){
      return alartTypes.AI
    } else if (alartType === alartTypes.AI) {
      return alartTypes.AI
    } else if (dataset_id.endsWith('_n_history')) {
        return alartTypes.NOTIFY
    } else if (dataset_id.endsWith('_sysalart')) {
        return alartTypes.IOT
    } else {
        return alartType
    }
}

export const getAlartTypeName = (dataset_id, alartType) => {
  const datasetAlartType = alartType ? alartType : getAlartType(dataset_id, alartType)
  if (datasetAlartType === alartTypes.ALARM) {
    return '現場警報'
  } else if (datasetAlartType === alartTypes.NOTIFY) {
    return 'クラウド設定警報'
  } else if (datasetAlartType === alartTypes.IOT) {
    return 'IoT機器警報'
  } else if (datasetAlartType === alartTypes.SYSTEM) {
    return 'システム警報'
  } else if (datasetAlartType === alartTypes.SAIIK) {
    return 'AI警報'
  } else if (datasetAlartType === alartTypes.AI) {
    return 'AI警報'
  } else {
    return '-'
  }
}

export const getAlartStatusName = (alartStatus) => {
  if (alartStatus === alartStatuses.OCCUR) {
    return '発生'
  } else {
    return '-'
  }
}

/**
 * 階層ごとのデータセット一覧取得
 * @param {*} nodes store.getters['common/node'](node_id) の返却値
 * @returns 階層IDをキーとした「dataset_id_details_list」の一覧
 */
export const getNodeDatasetList = (nodes) => {
  let datasetList = {}
  return getDatasetDetails(nodes, datasetList)
}
const getDatasetDetails = (nodes, datasetList) => {
  datasetList[nodes.id] = nodes.dataset_id_details_list
  for (const i in nodes.children_detail) {
    datasetList = getDatasetDetails(nodes.children_detail[i], datasetList)
  }
  return datasetList
}

/**
 * 警報履歴情報のデータセット名取得
 * @param {*} row 警報履歴の１行分
 * @param {*} datasetList getNodeDatasetList() で取得した値
 * @returns
 */
export const getDatasetNameByAlartList = (row, datasetList) => {
  let datasetName = ''
  if (!row.alart_type) {
    row.alart_type = getAlartType(row.dataset_id, row.field_type)
  }
  const target = datasetList[row.node_id]?.find(item => {
    if (row.alart_type == alartTypes.ALARM) {
      return item.dataset_id == row.dataset_id.replace(/(_alarm)$/, '')
    } else if (row.alart_type == alartTypes.IOT) {
      if (row.dataset_id.endsWith('_result_sysalart')) {
        return item.dataset_id == row.dataset_id.replace(/(_sysalart)$/, '')
      } else if (row.dataset_id.endsWith('_sysalart')) {
        return item.dataset_id.replace(/(_result)$/, '') == row.dataset_id.replace(/(_sysalart)$/, '')
      } else if (row.dataset_id.endsWith('_alarm')) {
        return item.dataset_id == row.dataset_id.replace(/(_alarm)$/, '')
      } else {
        return item.dataset_id == row.dataset_id
      }
    } else {
      return item.dataset_id == row.dataset_id.replace(/(_notify|_notify_n_history)$/, '')
    }
  })
  if (target) {
    if (row.alart_type == alartTypes.IOT && `${target.dataset_id.replace(/(_result)$/, '')}_sysalart` == row.dataset_id) {
      datasetName = target.dataset_name === null || target.dataset_name === '' ? target.dataset_id.replace(/(_result)$/, '') : target.dataset_name
    } else {
      datasetName = target.dataset_name === null || target.dataset_name === '' ? target.dataset_id : target.dataset_name
    }
  } else {
    if (row.alart_type == alartTypes.IOT && datasetList[row.node_id]?.find(item => row.dataset_id == item.dataset_id.replace(/(_result)$/, ''))) {
      datasetName = row.dataset_id
    }
  }
  return datasetName
}

/**
 * 中粒度の集計期間判定
 * @param {Array} summaries 集計期間一覧（例：['30min','1H']）
 * @param {String} selectFreq 選択したデータ間隔
 */
export const getMiddleGraphFreq = (summaries, selectFreq) => {
  let graphFreq = null
  if (summaries === null || summaries === '') {
    return null
  }
  if (!summaries.includes(selectFreq)) {
    let selectFreqNum = 0
    if (selectFreq.indexOf('min') !== -1) {
      selectFreqNum = Number(selectFreq.replace('min', ''))
    } else if (selectFreq.indexOf('H') !== -1) {
      selectFreqNum = Number(selectFreq.replace('H', '')) * 60
    }
    summaries.forEach((summary) => {
      let summaryNum = 0
      if (summary.indexOf('min') !== -1) {
        summaryNum = Number(summary.replace('min', ''))
      } else if (summary.indexOf('H') !== -1) {
        summaryNum = Number(summary.replace('H', '')) * 60
      }
      if (graphFreq == null & summaryNum >= selectFreqNum) {
        graphFreq = summary
      }
    })
  } else {
    graphFreq = selectFreq
  }
  return graphFreq
}

/**
 * メール通知設定一覧取得
 * @returns メール通知設定一覧
 */
export const getMailGroupSettings = () => {
  // canEditGeneral: 一般ユーザー編集権限
  return [
    { canEditGeneral: true  }, // 通知Gr1
    { canEditGeneral: true  }, // 通知Gr2
    { canEditGeneral: true  }, // 通知Gr3
    { canEditGeneral: true  }, // 通知Gr4
    { canEditGeneral: true  }, // 通知Gr5
    { canEditGeneral: true  }, // 通知Gr6
    { canEditGeneral: true  }, // 通知Gr7
    { canEditGeneral: false }, // 通知Gr8
  ]
}

/**
 * GatewayIF から取得したデータをソート（データセットID → 階層ID → gateway_if_row_order）
 * @param {*} rows 一覧情報（ gateway_if_row_order が入っているもの）
 * @returns 一覧情報（ソート用カラム dataset_display_order を追加）
 */
export const prepareSortGatewayIfOrder = (rows) => {
  const maxRowOrder = Math.max.apply(null, rows.map(function(row){return (row.gateway_if_row_order) ? row.gateway_if_row_order : 0;}))
  rows.forEach(row => {
    if (row.gateway_if_row_order === null) {
      row.gateway_if_row_order = maxRowOrder + 1
    }
  })
  const digit = Math.max.apply(null, rows.map(function(row){return (row.gateway_if_row_order) ? row.gateway_if_row_order : 0;})).toString().length
  rows.forEach(row => {
    // row.dataset_display_order = `${row.dataset_id}_${zeroPadding(row.gateway_if_row_order, digit)}`
    row.dataset_display_order = `${row.dataset_id}_${row.node_id}_${zeroPadding(row.gateway_if_row_order, digit)}`
  })
  return rows
}

function zeroPadding(num, len){
	return ( Array(len).join('0') + num ).slice( -len );
}


export function htmlEncode(input) {
  return input
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\n/g, '<br>');
}



/**
  Promiseとの操作を定義するクラス
*/
export class PromiseHandler {

    latestCallTiming = {};

    constructor(){

    }

    /**
      最後の呼び出しの結果を利用する、非同期の処理で最新の処理が早めに終わって前の呼び出しの結果が後で来て上書きされることを避ける
      @param {Promise} promise
      @returns {Promise}
    */
    useLatestOnly(promise, key){
      const currentCallTime = new Date().getTime()
      this.latestCallTiming[key] = currentCallTime;
      return new Promise((resolve, reject) => {
        promise
          .then((data) => {
              if (currentCallTime == this.latestCallTiming[key]){
                resolve(data);
              } else {
                console.log(`Skip result of ${key} called at ${new Date(currentCallTime)} because it is deprecated.`);
              }
          })
          .catch((err) => {
            if (currentCallTime == this.latestCallTiming[key]){
              reject(err);
            } else {
              console.log(`Skip error of ${key} called at ${new Date(currentCallTime)} because it is deprecated.`);
            }
          })
      });
    }

}

/**
 *
 * 水ing以外の組織のカメラで水ingユーザーがモデルを作成するケースは水ing以外の組織に対して作成者表示は「水ing」
 * @param {Object} userInfo
 * @param {string} last_name
 * @param {string} first_name
 * @param {string} organization_name
 * @returns string
 */
export const formatModelCreationUserName = (userInfo, last_name, first_name, organization_name) => {
  if (userInfo?.organization_name != "水ing" && organization_name == "水ing"){
    return "水ing";
  }
  return `${last_name ?? ''} ${first_name ?? ''}`.trim();
}

/**
 * 数値の桁数チェック
 * @param {*} val チェック対象の数値
 * @returns bool
 */
export const checkNumberDigit = (val) => {
  if (val === null || val === '') {
    return true
  }
  let str = String(val).replace('.', '').replace('-', '')
  if (str.length > 15) {
    return false
  }
  return true
}
/**
 * 数値の桁数チェック：エラー時のメッセージ
 * @param {*} itemName 項目名
 * @returns string
 */
export const checkNumberDigitMsg = (itemName) => {
  return `${itemName}は15桁以内で入力してください。`
}

/**
 * 文字数の上限チェック
 * @param {*} val チェック対象の文字列
 * @param {*} maxLength 上限数
 * @returns bool
 */
export const checkMaxLength = (val, maxLength) => {
  if (val === null || val === '') {
    return true
  }
  if (String(val).length > maxLength) {
    return false
  }
  return true
}

/**
 * 文字数の上限チェック：エラー時のメッセージ
 * @param {*} itemName 項目名
 * @param {*} maxLength 上限数
 * @returns string
 */
export const checkMaxLengthMsg = (itemName, maxLength) => {
  return `${itemName}は${maxLength}文字以下で入力してください。`
}

/**
 * 文字数の下限チェック
 * @param {*} val チェック対象の文字列
 * @param {*} minLength 下限数
 * @returns bool
 */
export const checkMinLength = (val, minLength) => {
  if (val === null || val === '') {
    return true
  }
  if (String(val).length < minLength) {
    return false
  }
  return true
}

/**
 * 文字数の下限チェック：エラー時のメッセージ
 * @param {*} itemName 項目名
 * @param {*} minLength 下限数
 * @returns string
 */
export const checkMinLengthMsg = (itemName, minLength) => {
  return `${itemName}は${minLength}文字以上で入力してください。`
}

/**
 * 範囲指定型の数値の大小チェック
 * @param {*} min チェック対象の数値（小）
 * @param {*} max チェック対象の数値（大）
 * @returns bool
 */
export const checkNumberRange = (min, max) => {
  if (min === null || min === '' || min === '-') {
    return true
  }
  if (max === null || max === '' || max === '-') {
    return true
  }
  if (Number(min) > Number(max)) {
    return false
  }
  return true
}
/**
 * 範囲指定型の数値の大小チェック：エラー時のメッセージ
 * @param {*} minItemName 項目名（小）
 * @param {*} maxItemName 項目名（大）
 * @returns string
 */
export const checkNumberRangeMsg = (minItemName, maxItemName) => {
  return `${maxItemName}は${minItemName}以上の値を設定してください。`
}

/**
 * ペアで入力すべき値が両方とも入力されているかチェック。
 * 両方とも値が入っているか、両方とも値が入っていない場合に限り true を返す。
 * @param {*} one
 * @param {*} other
 * @returns boolean
 */
export const checkCoupledValues = (one, other) => {
  const oneIsNullValue = (one == null || one === '')
  const otherIsNullValue = (other == null || other === '')
  return oneIsNullValue === otherIsNullValue
}

/**
 * ペアで入力すべき値が両方とも入力されているかチェック時のエラーメッセージ。
 * @param {*} one
 * @param {*} other
 * @returns string
 */
export const checkCoupledValuesMsg = (one, other) => {
  return `${one}と${other} はセットで入力してください。`
}

/**
 * 日付の形式チェック
 * @param {String} date 日付文字列
 * @returns bool
 */
export const checkDate = (date) => {
  if (date == null || date == '') {
    return true
  }
  if (!/^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(date)) {
    return false
  }
  if (!moment(formatISO(date)).isValid()) {
    return false
  }
  // 上記のチェックでは 4/31 等も許容してしまうので、変換後の日付が一致しているかもチェック
  const dateArr = date.split('/')
  if (moment(formatISO(date)).year() == Number(dateArr[0])
    && moment(formatISO(date)).month() + 1 == Number(dateArr[1])
    && moment(formatISO(date)).date() == Number(dateArr[2])) {
      return true
  }
  return false
}

/**
 * 日時の形式チェック
 * @param {String} dateTime 日時文字列
 * @param {Boolean} seconds 秒を含むか
 * @returns bool
 */
export const checkDateTime = (dateTime, seconds=false) => {
  if (dateTime == null || dateTime == '') {
    return true
  }
  let check = true
  if (seconds) {
    check = /^([\d]+\/[0-1]\d\/[0-3]\d) ([0-1]?\d|2[0-3]):([0-5]\d):([0-5]\d)$/.test(dateTime)
  } else {
    check = /^([\d]+\/[0-1]\d\/[0-3]\d) ([0-1]?\d|2[0-3]):([0-5]\d)$/.test(dateTime)
  }
  if (!check) {
    return false
  }
  const dateTimeArr = dateTime.split(' ')
  return checkDate(dateTimeArr[0])
}

/**
 * 時間の形式チェック
 * @param {String} val  チェック対象の文字列
 * @returns bool
 */
export const checkTime = (val) => {
  if (val == null || val == '') return true
  const re = /^([0-1]?\d|2[0-3]):[0-5]\d$/
  return re.test(val)
}

/**
 * 開始時間と終了時間が逆転していないかチェック
 * @param {String} strStartTime 開始時間の文字列
 * @param {String} strEndTime 終了時間の文字列
 * @returns bool
 */
export const checkTerm = (strStartTime, strEndTime) => {
  if (strStartTime == null || strStartTime == '' || !checkTime(strStartTime)) {
    return true
  }
  if (strEndTime == null || strEndTime == '' || !checkTime(strEndTime)) {
    return true
  }
  const sArr = String(strStartTime).split(':')
  const eArr = String(strEndTime).split(':')
  const startTime = sArr.length == 3 ? moment().startOf('day').hour(sArr[0]).minute(sArr[1]).seconds(sArr[2]) : moment().startOf('day').hour(sArr[0]).minute(sArr[1]).seconds(0)
  const endTime = eArr.length == 3 ? moment().startOf('day').hour(eArr[0]).minute(eArr[1]).seconds(eArr[2]) : moment().startOf('day').hour(eArr[0]).minute(eArr[1]).seconds(0)
  if (startTime > endTime) {
    return false
  }
  return true
}

/**
 * メールアドレス形式チェック
 * @param {String} val チェック対象の文字列
 * @returns bool
 */
export const checkEmail = (val) => {
  if (val == null || val == '') return true
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(val)
}

/**
 * 名称の入力文字チェック
 * @param {*} val チェック対象の文字列
 * @returns bool
 */
export const checkNameRegulation = (val) => {
  // const pattern = /^[0-9a-zA-Z ぁ-んァ-ヶｱ-ﾝﾞﾟ０-９一-龠　!"#$%&'()*+-.,\/:;<=>?@[\]^_`{|}~！”＃＄％＆’（）ー＝＾〜￥｜＠｀「」『』｛｝【】；：＋＊＜＞、。・？／＿]*$/
  // 入力可能な文字は以下とする。
  // ・半角・全角の英数字
  // ・ギリシャ文字 (\u0370-\u03FF)
  // ・漢字（\u4E00-\u9FFF）
  // ・ひらがな（\u3040-\u309F）
  // ・カタカナ（\u30A0-\u30FF）
  // ・半角カタカナ（\uFF61-\uFF9F）
  // ・その他かっこ・句読点・アンダースコア・温度・パーセント・スラッシュ
  const pattern = /^[0-9０-９a-zA-Z\u0370-\u03FF\u4E00-\u9FFF\u3040-\u309F\u30A0-\u30FF\uFF61-\uFF9F 　()（）\-[\]{}｛｝,、.。_＿℃%％/／]*$/
  if (val === null || val === '') {
    return true
  }
  if (!new RegExp(pattern).test(val)) {
    return false
  }
  return true
}
/**
 * 名称の入力文字チェック：エラー時のメッセージ
 * @param {*} itemName 項目名
 * @returns string
 */
export const checkNanmeRegulationMsg = (itemName) => {
  return `${itemName}は特殊文字の入力はできません。`
}

/**
 * 半角英数字チェック
 * @param {*} val チェック対象の文字列
 * @returns bool
 */
export const checkAlphanumeric = (val) => {
  const pattern = /^[0-9a-zA-Z]*$/
  if (val === null || val === '') {
    return true
  }
  if (!new RegExp(pattern).test(val)) {
    return false
  }
  return true
}
/**
 * 名称の入力文字チェック：エラー時のメッセージ
 * @param {*} itemName 項目名
 * @returns string
 */
export const checkAlphanumericMsg = (itemName) => {
  return `${itemName}は半角英数字で入力してください。`
}

/**
 * 補正計算入力チェック
 *
 * ルール:
 *  ・/ * + - のいずれかで始まる
 *  ・使用可能な記号: / * . ( ) + -
 *  ・数字の連続は許可
 *  ・( ) は何度連続してもよい
 *  ・/ * は2回まで連続可（3回以上は不可）
 *  ・. + - は連続不可
 *  ・/の後の整数0は禁止（/0.5 は許可）
 *  ・0始まり数値は不可（0.xx は許可）
 *  ・小数点が複数回出現する数値は不可（0.8.3 等）
 *  ・( と ) の数が一致すること
 *  ・( の前に数字は不可
 *  ・) の後に数字は不可
 *  ・. は ( または ) の前後禁止
 *  ・/ * + は ( の直後禁止（- は負の数の符号として許可）
 *  ・(- の後は数字であること
 *  ・/ * + - は ) の直前禁止
 *  ・() 空括弧禁止
 *  ・式に初めて登場する括弧は ( でなければならない
 * 
 * 例）/2、*0.83、/60*5、//2、**2、/28*0.5/32、/60*((3.8+2.5)/2)、*(-5)、*60/-7
 * @param correction 補正計算入力値
 */
export const validateCorrection = (correction) => {
  if (!correction)
    return true

  // 使用可能文字チェック: 数字と / * . ( ) + - のみ
  if (/[^0-9/*.()+\-]/.test(correction))
    return false

  // / * + - のいずれかで始まること
  if (!/^[/*+\-]/.test(correction))
    return false

  // 数字を含むこと
  if (!/\d/.test(correction))
    return false

  // 記号で終わらないこと（末尾は数字または ) であること）
  if (!/[\d)]$/.test(correction))
    return false

  // / * は3回以上連続不可
  if (/\/{3,}|\*{3,}/.test(correction))
    return false

  // . + - は連続不可
  if (/\.{2,}|\+{2,}|-{2,}/.test(correction))
    return false

  // .の前後は数字であること（小数点としての使用のみ許可）
  if (/\.[^0-9]|[^0-9]\./.test(correction))
    return false

  // 0始まり数値の禁止（0のみ or 0.xx は許可、01xx 等は不可）
  // 数字列を抽出して個別チェック
  const numbers = correction.match(/\d+(\.\d+)?/g)
  if (numbers) {
    for (const num of numbers) {
      // 0始まりで2桁以上の整数部は不可 (012, 0120 等)
      if (/^0\d/.test(num) && !/^0\./.test(num))
        return false
      // 小数点が複数あるかチェック（0.8.3のようなケース）
      // マッチは最長一致なので、元文字列側でチェック
    }
  }

  // 0.8.3 のような数値中の小数点複数出現を検出
  // 数字.数字.数字 のパターンを禁止
  if (/\d+\.\d+\.\d+/.test(correction))
    return false

  // /の直後の整数0は禁止（/0 は不可、/0.5 は許可）
  // //, //0.5 等も考慮
  if (/\/{1,2}0(?!\.)/.test(correction))
    return false

  // ( と ) の数が一致すること
  const openCount = (correction.match(/\(/g) || []).length
  const closeCount = (correction.match(/\)/g) || []).length
  if (openCount !== closeCount)
    return false

  // ( の前に数字は不可（例: 3(... は不可）
  if (/\d\(/.test(correction))
    return false

  // ) の後に数字は不可（例: )3 は不可）
  if (/\)\d/.test(correction))
    return false

  // . は ( または ) の前後禁止
  if (/\.\(|\(\.|\.\)|\)\./.test(correction))
    return false

  // / * + は ( の直後禁止（- は負の数の符号として許可）
  if (/\([/*+]/.test(correction))
    return false

  // (- の後は数字であること（負の数の符号として使用）
  if (/\(-[^0-9]/.test(correction) || /\(-$/.test(correction))
    return false

  // / * + - は ) の直前禁止
  if (/[/*+\-]\)/.test(correction))
    return false

  // () 空括弧禁止
  if (/\(\)/.test(correction))
    return false

  // 式に初めて登場する括弧は ( でなければならない
  if (/[()]/.test(correction) && correction.search(/[()]/) === correction.indexOf(')'))
    return false

  return true
}

/**
 * ドキュメント管理のフォルダ・ファイル名の入力チェック
 * 
 * 使用できる文字は以下とする。
 * ・全角文字（日本語、記号含む）
 * ・半角英数字（a-z、A-Z、0-9）
 * ・ハイフン（-）
 * ・アンダーバー（_）
 * ・ピリオド（.）
 * ・括弧（ () ）
 * ・スペース
 * @param {*} name フォルダ名またはファイル名
 * @returns bool 使用可能な文字のみの場合はtrue、使用できない文字が含まれる場合はfalse
 */
export const validateDocumentName = (name) => {
  if (!name) return true
  var reg = new RegExp(/[^\u3000-\u9FFF\uF900-\uFAFF\uFF01-\uFF60\uFFE0-\uFFE6\u2018-\u201Da-zA-Z0-9\-_.() ]/);
  var res = reg.test(name);
  return !res
}

/**
 * キャンセルトークン発行
 */
export class RequestCanceler {
  source = axios.CancelToken.source();
  constructor() {}

  /**
   * キャンセル実行
   */
  cancel() {
    this.source.cancel()
    this.source = axios.CancelToken.source()
  }

  /**
   * キャンセルトークン生成（リクエスト実行時に付与）
   * @returns キャンセルトークン
   */
  token() {
    return this.source.token
  }
}
